import { kodlamalariCoz } from './email-mask-decoders';
import { atillariSecerek, atillariSok, boslugaIndirge, } from './email-mask-structure';
/* --- 1. KATLAMAYI AÇ ------------------------------------------------------
 *
 * İKİ AYRI RFC, İKİ AYRI KATLAMA — ve bu turda ikincisi kaçtı.
 *
 * RFC 5322 §2.2.3 (başlık katlaması): `\r\n` + BOŞLUK. Gmail'in
 * `<ali@\r\n ornek.com>` biçimi budur.
 *
 * RFC 5321 §4.2.1 (çok satırlı YANIT): devam eden her satır yanıt KODUYLA
 * başlar — `<ali@\r\n550-5.1.1 ornek.com>`. Eski desen yalnız birincisini
 * tanıyordu; ikincisinde yerel ad ve alan adı AYRI AYRI ham kalıyordu.
 * Genişletilmiş durum kodu (`5.1.1`) seçmelidir: her sağlayıcı yazmaz.
 */
const SMTP_COK_SATIRLI_YANIT = /\r?\n[ \t]*\d{3}[- ][ \t]*(?:\d{1,3}\.\d{1,3}\.\d{1,3})?[ \t]*/g;
const BASLIK_KATLAMASI = /\r?\n[ \t]+/g;
function katlamayiAc(metin) {
    return metin.replace(SMTP_COK_SATIRLI_YANIT, '').replace(BASLIK_KATLAMASI, '');
}
/* --- 2. KODLAMALARI ÇÖZ (SABİT NOKTAYA KADAR) -----------------------------
 *
 * ÇİFT KODLAMA BU ADIMIN VARLIK SEBEBİDİR: `%2540` tek turda `%40` olur,
 * ikinci turda `@`. Çözücülerin tamamı ve gerekçeleri ayrı dosyadadır
 * (`email-mask-decoders.ts`); buradan yalnız ADIM olarak çağrılır ve kamuya
 * açık yüzey (`kodlamalariCoz`, `KOD_COZUM_TAVANI`) aynı yerden verilmeye
 * devam eder — spec ve çağıranlar `./email-mask`i import etmeyi sürdürür.
 */
export { KOD_COZUM_TAVANI, kodlamalariCoz } from './email-mask-decoders';
/* --- 3. GÖRÜNMEZLERİ SÖK --------------------------------------------------
 *
 * EKRANDA `ali@ornek.com` OKUNUYOR AMA DESEN GÖREMİYOR: `ali<U+200B>@ornek.com`
 * (sıfır genişlikli boşluk), `ali<U+00AD>@…` (yumuşak tire) ve
 * `ali<NBSP>@<NBSP>…` üçü de bu turda ham geçti. Kusurun ağırlığı burada:
 * maskeleme BAŞARILI görünürken kişisel veri ekranda GÖZLE OKUNUYORDU.
 *
 * `\p{Cf}` (biçim) sınıfı sıfır genişlikli boşluk/birleştirici, yumuşak tire,
 * kelime birleştirici ve BOM'u tek kalemde kapsar — tek tek sayılmaz.
 * BOŞLUK SINIFI (`\p{Zs}`) için ASCII boşluğu DIŞARIDA bırakılır ve gerisi
 * SİLİNİR (boşluğa çevrilmez): NBSP ayırıcı görevi görmez, adresin ortasına
 * sokulan görünmez bir karakterdir ve silinmesi fail-closed yöndür.
 * `\p{M}` (birleştirici işaret) SÖKÜLMEZ: Türkçe ve ayrıştırılmış diziler
 * (`i̇`) onlarla yazılır.
 */
/*
 * KONTROL KARAKTERLERİ DE SÖKÜLÜR (tech-lead, 16.09.2026). Çözücüler ASCII
 * olmayan sekizlileri metne taşıyabilir (`%00`, `&#144;`) ve sonuç kalıcı
 * kolona yazılır: NUL bir `text` kolonuna HİÇ yazılamaz (Postgres reddeder,
 * işçi kalıcı hataya düşer), C1 karakterleri ise ekranda GÖRÜNMEZ durur.
 * Sekme ve satır sonu korunur — teşhis metninin biçimidir.
 */
const GORUNMEZ = /\p{Cf}|(?! )\p{Zs}|(?![\t\n\r])\p{Cc}/gu;
function gorunmezleriSok(metin) {
    return metin.replace(GORUNMEZ, '');
}
/* --- 4. UNICODE NFKC ------------------------------------------------------
 *
 * Tam genişlikli `＠` (U+FF20) ve `．` (U+FF0E) burada kendiliğinden `@` ve `.`
 * olur; ROMAN RAKAMLARI, matematiksel harf biçimleri ve daktilo genişlikli
 * varyantlar da öyle. Bu adım sayesinde `AT` diye bir KAPALI LİSTE yoktur —
 * eski desendeki `(?:@|＠|%40|…)` alternatifi bütünüyle kaldırıldı.
 *
 * NFC DEĞİL NFKC: NFC yalnız kanonik denkliği çözer, `＠` NFC'de `＠` kalır.
 */
export const NORMALIZASYON_ADIMLARI = [
    { ad: 'katlamayi-ac', uygula: katlamayiAc },
    { ad: 'kodlamalari-coz', uygula: (metin) => kodlamalariCoz(metin) },
    /*
     * 2.5. ATIL MADDEYİ SÖK — YAPISAL İNDİRGEMENİN BİRİNCİ AYAĞI.
     * ÇÖZÜCÜLERDEN SONRA gelir ve sırası bilinçlidir: `&#60;span&#62;` önce
     * `<span>` olmalı ki etiket olarak sökülebilsin. Ters sırada kodlanmış
     * etiket sızardı.
     */
    {
        ad: 'atillari-sok',
        uygula: atillariSok,
        secimli: (metin, ayrilan, kip) => atillariSecerek(metin, ayrilan, undefined, kip),
    },
    /*
     * 2.6. `@`YE BİTİŞİK BOŞLUĞU TEK BOŞLUĞA İNDİR — YAPISAL İNDİRGEMENİN
     * İKİNCİ AYAĞI ve `ARA_ESIGI`nin tabanı.
     *
     * ATIL SÖKÜMDEN SONRA gelir ve sırası bilinçlidir: `ali <span></span> @ …`
     * önce etiketten arınır, geriye kalan boşluk kümesi burada çöker. Panelde
     * HTML zaten aynısını yapar (ardışık boşluk tek boşluk çizilir), yani
     * kanonik biçim personelin GÖRDÜĞÜ biçimdir. Eşikli eski hâl dokuz
     * boşlukla, satır sonuyla ve `%20` dolgusuyla atlatılıyordu.
     */
    { ad: 'bosluga-indirge', uygula: boslugaIndirge },
    { ad: 'gorunmezleri-sok', uygula: gorunmezleriSok },
    { ad: 'unicode-nfkc', uygula: (metin) => metin.normalize('NFKC') },
];
/**
 * ZİNCİR SABİT NOKTAYA KADAR KOŞAR — ADIM SIRASI ARTIK BİR AÇIK DEĞİL.
 *
 * Sıralı tek geçişte her adım yalnız KENDİNDEN SONRAKİ adımları besleyebilir:
 * bir adımın çıktısı ÖNCEKİ bir adımın işini açıyorsa o iş hiç yapılmazdı
 * (ör. atıl söküm iki kodlanmış parçayı birleştirip yeni bir kaçış ortaya
 * çıkarırsa, çözücü adımı çoktan geçmiştir). Sıralamayı "doğru kurmak" bu
 * sorunu çözmez, yalnız erteler — dört dalga boyunca kaçan şey tam olarak bu
 * tür bileşimlerdi.
 *
 * Zincir bu yüzden DEĞİŞMEZ OLANA KADAR yinelenir. Tavan sonsuz döngüye karşı
 * emniyet payıdır; adımların hepsi ya kısaltır ya idempotenttir.
 *
 * TAVAN ÖLÇÜLDÜ, TAHMİN EDİLMEDİ (tech-lead, 16.09.2026). Korpustaki elli
 * kaçamağın TAMAMI en çok 2 turda sabit noktaya oturuyor (ikincisi "değişmedi"
 * turudur), yani gerçek ihtiyaç 2'dir. Katmanları bilerek üst üste bindiren
 * yapay bir girdi (`%25%32%35%34%30` + etiketle bölünmüş `%40`) 3 tur istiyor.
 * Tavan bir tur PAY bırakır: 4.
 *
 * SAYI BAYATLAMAZ: `email-mask.spec.ts` 14f. AYAK korpusun her satırının kaç
 * turda oturduğunu ÖLÇER ve tavanın altında kalmasını şart koşar. Bir gün
 * daha derin bir bileşim gelirse test KIRILIR — tavan sessizce fail-open
 * olamaz (`EMAIL_MASK_SOURCE_CEILING` başlığındaki sınıfın aynısı).
 */
export const NORMALIZASYON_TAVANI = 4;
/** Adımları sabit noktaya kadar uygular. Alt küme verilebilir — mutasyon probu böyle koşar. */
export function normalizeForMasking(value, adimlar = NORMALIZASYON_ADIMLARI, tavan = NORMALIZASYON_TAVANI) {
    let metin = value;
    for (let tur = 0; tur < Math.max(1, tavan); tur += 1) {
        const sonraki = adimlar.reduce((ara, adim) => adim.uygula(ara), metin);
        if (sonraki === metin)
            break;
        metin = sonraki;
    }
    return metin;
}
//# sourceMappingURL=email-mask-normalize.js.map